export default __webpack_public_path__ + "static/media/img_13.ce515d63.JPG";